export default __webpack_public_path__ + "static/media/ic_broadband.96d2a8c7.svg";